import { TicketRepository } from '../repositories/TicketRepository'

export function ListTicketForAssignAttachmentCase(
  ticketRepository: TicketRepository
) {
  return async function ({
    ticketId,
    areaId
  }: {
    ticketId: string
    areaId: string
  }) {
    return await ticketRepository.listTicketForAssignAttachment({
      ticketId,
      areaId
    })
  }
}
